import { reactive } from 'vue'
import { useApiGetAuthUserInfo } from '../api'
import { captureMessage, setUser } from '@/utils/sentry'
import { useGlobalError } from './useGlobalError'

type RoleType = 'admin' | 'user' | 'none'
type ModuleType = 'domeos' | 'redis'

// 用户信息类型
export interface UserInfo {
  name: string
  email: string
  department: string
  mobile: string
  phone: string
  wechatBound: boolean
  avatar?: string
  permissions: Map<ModuleType, RoleType>
}

// 用户设置类型
export interface UserSettings {
  notifications: boolean
  theme: 'light' | 'dark' | 'system'
  language: 'zh-CN' | 'en-US'
}

// 全局用户状态
const userState = reactive<UserInfo>({
  name: '',
  email: '',
  department: '',
  mobile: '',
  phone: '',
  wechatBound: false,
  avatar: '',
  permissions: new Map()
})

export function useUserStore() {
  const { execute } = useApiGetAuthUserInfo()
  const { showGlobalError } = useGlobalError()

  // === 用户数据方法 ===
  // 获取用户信息（必须先调用，避免未认证导致多次401）
  const fetchUserInfo = async () => {
    if (userState.email) return
    const code = await new Promise<string>((res, rej) => {
      window.hxe.getCode({
        clientId: import.meta.env.VITE_CLIENT_ID,
        success({ code }) {
          document.cookie = `hxeCode=${code}`
          sessionStorage.setItem('hxeCode', code)
          // @ts-ignore
          globalThis._hxeCode = code
          res(code)
        },
        fail() {
          captureMessage(`获取到的code失败`)
          document.cookie = 'hxeCode='
          sessionStorage.removeItem('hxeCode')
          // todo: handle failure
          showGlobalError('发生错误', '狐小E code获取失败')
          rej(null)
        }
      })
    })
    const data = await execute(
      {},
      {
        invalidateCache: true
      }
    )
    userState.name = data?.userName || ''
    userState.email = data?.email || ''
    userState.department = data?.department || ''
    userState.phone = String(data?.phone || '')
    userState.mobile = String(data?.mobile || '')
    userState.wechatBound = data?.wxStatus === 1
    userState.avatar = ''
    userState.permissions = new Map(
      data?.perms?.map(perm => [
        perm.module as ModuleType,
        perm.hasAuth ? 'user' : 'none'
      ]) || []
    )
    setUser({
      email: userState.email,
      username: userState.name,
      code
    })
  }

  return {
    // 状态
    userState,

    // 方法
    fetchUserInfo
  }
}
